<template>
  <v-chip v-bind="$attrs" v-on="$listeners">
    <slot />
  </v-chip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CfsChip',
});
</script>
